import React, { useState, useEffect } from "react";
import "./login.scss";
import { IoLocationOutline } from "react-icons/io5";

// Imágenes slider
import img1 from "../../assets/loginImg/bsk1.jpg";
import img2 from "../../assets/loginImg/bsk2.jpg";
import img3 from "../../assets/loginImg/bsk3.jpg";
import img4 from "../../assets/loginImg/bsk4.jpg";
import img5 from "../../assets/loginImg/bsk5.jpg";
import img6 from "../../assets/loginImg/bsk6.jpg";

const images = [img1, img2, img3, img4, img5, img6];
const labels = [
    "Bershka Barcelona",
    "Bershka Gran Vía, Madrid",
    "Bershka Berlín",
    "Bershka Berlín",
    "Bershka Londres",
    "Bershka Valencia",
];

// Marco común de las pantallas de acceso (login y definir contraseña): carrusel de
// tiendas a la izquierda en Bershka y el formulario a la derecha.
export default function LoginLayout({ children }) {
    const isBershka = window.config?.isBershka;
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        if (!isBershka) return undefined;
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [isBershka]);

    return (
        <div className={`login ${isBershka ? "" : "login__notBSK"}`}>
            {isBershka && (
                <div className="login__left">
                    <div className="login__left__carousel">
                        {images.map((img, index) => (
                            <div
                                key={index}
                                className={`login__left__image-container ${
                                    index === currentImage ? "active" : ""
                                }`}
                            >
                                <img
                                    src={img}
                                    className="login__left__image"
                                    alt={`Imagen ${index + 1}`}
                                />
                                <div className="login__left__label">
                                    <span className="location-icon">
                                        <IoLocationOutline size={24} />
                                    </span>
                                    {labels[index]}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="login__right">{children}</div>
        </div>
    );
}
